import {DTO} from '@/shared/base/dto';
import {ENDPOINT, METHOD} from '@/constants';

export class GetSettingDTO extends DTO {
  public url = ENDPOINT.SETTING;
  public method = METHOD.GET;
  public body: undefined;
  public query: undefined;
  public param: undefined;
}
export class UpdateSettingDTO extends DTO {
  public static url = ENDPOINT.SETTING;
  public url = ENDPOINT.SETTING;
  public method = METHOD.PUT;
  public query: undefined;
  public param: undefined;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(public body: any) {
    super();
  }
}
